










import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentFeedType } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "CreatePostButton",
  components: { BaseButton, BaseIcon },
  props: {
    userId: { type: String, required: true },
    type: { type: String as () => ContentFeedType, default: undefined },
  },
  setup(props) {
    const { authUser, authorities } = useAuthUser();
    const loading = ref(false);

    const requiredAuthorities = computed<string[]>(() => {
      const isAuthor = (authUser.value && authUser.value.id === props.userId) || false;
      return isAuthor ? ["createMyContentSet"] : ["createAnyContentSet"];
    });

    const allowCreate = computed(() => {
      return checkAuthorities(authorities.value, requiredAuthorities.value);
    });

    const onClick = () => {
      emitter.emit(EVENTS.SHOW_CREATE_POST, { userId: props.userId, type: props.type });
    };

    return { authUser, loading, allowCreate, onClick };
  },
});
